
const WECHAT_APP_ID = "wxb59cb001f08739b1"

const appConfig = {
    WECHAT_APP_ID
}

export default appConfig